import { FC, useEffect, useRef, useState } from "react";
import { AITabs } from "./../../../components/aio/aio-input";
import { I_model, I_tab } from "../types";
import { UserInfoForm } from "./user-info-form";
import { CarInfoForm } from "./car-info-form";
import Footer from "./footer";
import { useFreelancerProvider, useRootFreelancerProvider } from "../context";
import { ImagesForm } from "./images-form";
import { CitiesForm } from "./cities-form";
import { NumbersForm } from "./numbers-form";
import AIODate from "./../../../components/aio/aio-date";
import { FakeName, GetRandomNumber, ShuffleArray } from "components/aio/aio-utils";
const Form: FC<{ id?: number }> = ({ id }) => {
    const { apis, popup, options } = useRootFreelancerProvider()
    const { gridHook, tabsDic, typesDic } = useFreelancerProvider()
    const [tab, setTab] = useState<I_tab>("userInfo")
    const [mode, setMode] = useState<'add' | 'edit'>(id === undefined ? 'add' : 'edit')
    const [data, setData] = useState<I_model>()
    const dataRef = useRef<I_model>(data)
    dataRef.current = data
    const setNextTab = () => {
        const possibleTabs = typesDic[data.type.id.toString()].tabs;
        const tabIndex = possibleTabs.indexOf(tab);
        const newTabIndex = tabIndex + 1;
        const newTab = possibleTabs[newTabIndex];
        if (newTab) { setTab(newTab) }
        else { popup.removeModal() }
    }
    const getData = async () => {
        if (id === undefined) {
            const a = window.location.href;
            const isLocal = a.indexOf("http://myboxi:3000") === 0
            setData(getAdd(isLocal))
        }
        else {
            const res = await apis.initialEdit(id);
            if (res) { setData(res) }
        }
    }
    useEffect(() => {
        getData()
    }, [])
    const submit = async () => {
        const data = dataRef.current
        if (!data) { return }
        const hubObject = options.hubs.find((o: any) => o.id === data.hubId) as any
        let obj: I_model = {
            ...data,
            birthDate: new AIODate().toIsoDate(data.birthDate),
            username: data.mobile,
            hubCodes: [hubObject.code],
        };

        if (mode === 'add') {
            const res = await apis.add(obj)
            if (!res) { return }
            setMode('edit');
            setData(res)
        }
        else {
            const res = await apis.edit(obj)
            if (!res) { return }
        }
        gridHook.updateGrid()
        setNextTab()
        popup.addSnackebar({ type: 'success', text: `${mode === 'add' ? 'افزودن' : 'ویرایش'} با موفقیت انجام شد`, align: ['right', 'top'] })
    }
    if (!dataRef.current) { return null }
    const tabOptions = (Object.keys(tabsDic) as I_tab[]).map((key) => {
        return { text: tabsDic[key].text, value: key, show: tabsDic[key].employeeTypes.indexOf(dataRef.current.type.id) !== -1, disabled: mode === 'add' && key !== "userInfo" }
    })
    const changeDataByObject = (obj: Partial<I_model>) => setData({ ...dataRef.current, ...obj })
    return (
        <div className="p-24- h-100-" style={{ background: '#fff' }}>
            <div className="flex-col- gap-16-">
                <AITabs
                    style={{ height: 36 }}
                    options={tabOptions}
                    value={tab}
                    className='brd-c-14- brd-b-'
                    option={{ justify: () => true, style: () => ({ flex: 1 }) }}
                    onChange={(tab) => setTab(tab)}
                />
                {tab === "userInfo" && <UserInfo mode={mode} data={data} onChange={(newData) => changeDataByObject(newData)} onSubmit={submit} />}
                {tab === "carInfo" && <CarInfo data={data} onChange={(newData) => changeDataByObject(newData)} onSubmit={submit} />}
                {tab === "cities" && <Cities data={data} onChange={(newData) => changeDataByObject(newData)} onSubmit={submit} />}
                {tab === "images" && <Images data={data} onChange={(newData) => changeDataByObject(newData)} onSubmit={submit} />}
            </div>
        </div>
    )
}
export default Form


type I_UserInfo = {
    onSubmit: () => void,
    data: I_model,
    mode: 'add' | 'edit',
    onChange: (v: I_model) => void
}
const UserInfo: FC<I_UserInfo> = ({ onSubmit, data, mode, onChange }) => {
    const { popup } = useRootFreelancerProvider()
    const [disabled, setDisabled] = useState<{ userInfo: boolean, numbers: boolean }>({ userInfo: true, numbers: true })
    const disabledRef = useRef<{ userInfo: boolean, numbers: boolean }>(disabled)
    disabledRef.current = disabled
    const changeDisabled = (field: 'userInfo' | 'numbers', value: boolean) => {
        console.log(field, value)
        const newDisabled = { ...disabledRef.current, [field]: value }
        disabledRef.current = newDisabled
        setDisabled(newDisabled)
    }
    const isDisabled = !!disabled.userInfo || !!disabled.numbers
    return (
        <>
            <UserInfoForm
                mode={mode} data={data}
                onChange={(newData) => onChange(newData)}
                setDisabled={(v) => changeDisabled('userInfo', v)}
            />
            <NumbersForm
                type={data.type.id} data={data}
                onChange={(newData) => onChange(newData)}
                setDisabled={(v) => changeDisabled('numbers', v)}
            />
            <Footer onSubmit={onSubmit} onClose={() => popup.removeModal()} disabled={isDisabled} />
        </>
    )
}
type I_CarInfo = { onSubmit: () => void, data: I_model, onChange: (v: I_model) => void }
const CarInfo: FC<I_CarInfo> = ({ onSubmit, data, onChange }) => {
    const { popup } = useRootFreelancerProvider()
    const [disabled, setDisabled] = useState<{ carInfo: boolean }>({ carInfo: true })
    const disabledRef = useRef<{ carInfo: boolean }>(disabled)
    disabledRef.current = disabled
    const changeDisabled = (field: 'carInfo', value: boolean) => {
        console.log(field, value)
        const newDisabled = { ...disabledRef.current, [field]: value }
        disabledRef.current = newDisabled
        setDisabled(newDisabled)
    }
    return (
        <>
            <CarInfoForm data={data} onChange={(newData) => onChange(newData)} setDisabled={(v) => changeDisabled('carInfo', v)} />
            <Footer onSubmit={onSubmit} onClose={() => popup.removeModal()} disabled={!!disabled.carInfo} />
        </>
    )
}

type I_Cities = { onSubmit: () => void, data: I_model, onChange: (v: { accessProvinces: { id: number }[], accessCities: { id: number }[] }) => void }
const Cities: FC<I_Cities> = ({ onSubmit, data, onChange }) => {
    const { popup } = useRootFreelancerProvider()
    const [disabled, setDisabled] = useState<{ cities: boolean }>({ cities: true })
    return (
        <>
            <CitiesForm data={data} onChange={(cities) => onChange(cities)} setDisabled={(v) => setDisabled({ ...disabled, cities: v })} />
            <Footer onSubmit={onSubmit} onClose={() => popup.removeModal()} disabled={!!disabled.cities} />
        </>
    )
}

const Images: FC<{ onSubmit: () => void, data: I_model, onChange: (v: I_model) => void }> = ({ onSubmit, data, onChange }) => {
    const { popup } = useRootFreelancerProvider()
    return (
        <>
            <ImagesForm data={data.images} onChange={(newImages) => onChange({ ...data, images: newImages })} />
            <Footer onSubmit={onSubmit} onClose={() => popup.removeModal()} disabled={false} />
        </>
    )
}





function getAdd(isLocal: boolean):I_model {
    if (!isLocal) {
        return {
            type: { id: 0 },
            gender: { id: 0 },
            isActive: true,
            images: {}
        }
    }
    const chars = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']
    const allchars = chars.concat(chars,chars);
    const shuffle = ShuffleArray(allchars)
    const mail = shuffle.slice(0,7).join('') + '.' + shuffle.slice(12,22).join('') + '@gmail.com'
    const mock: I_model = {
        "id": 12125,
        "nationalCode": "03864" + GetRandomNumber(1111, 9999) + '4', 
        "name": FakeName({ type: "fullname", lang: "fa" }),
        "mobile": "0912" + GetRandomNumber(1111111, 9999999),
        "email": mail,
        "username": "9470603524",
        "isSuperAdmin": false,
        "isActive": true,
        "hubId": 2,
        "fatherName": "محمد رضا علیزاده",
        "residentAddress": "تهران شهروردی شمالی حکیمی نژاد پلاک 56",
        "essentialPhone": "02188050006",
        "phone": "02188657890",
        "birthDate": "1369/2/10",
        "gender": { "id": 1 },
        "type": { "id": 0 },
        "iban": "565545678323458798767845",
        "drivingLicenceNo": "567566456546",
        "bankPaperNo": "75645657",
        "contractNo": "89785466",
        "recommenderCode": "12345678",
        "residentCity":{id:1126},
        images: {}
    }
    return mock
}